export default __webpack_public_path__ + "static/media/loginCartoonFall.476f2d4c.png";